import { translate } from '../i18n';

export const bookingHeader = [
  { label: translate('viewBookings.tableColumn.date') },
  { label: translate('viewBookings.tableColumn.id') },
  { label: translate('viewBookings.tableColumn.status') },
  { label: translate('viewBookings.tableColumn.name') },
  { label: translate('viewBookings.tableColumn.pretravel') },
  { label: translate('viewBookings.tableColumn.cxl') },
  { label: translate('viewBookings.tableColumn.adult') },
  { label: translate('viewBookings.tableColumn.child') },
  { label: translate('viewBookings.tableColumn.infant') },
  { label: translate('viewBookings.tableColumn.d1OpsChecklist') },
  { label: translate('viewBookings.tableColumn.time') },
  { label: translate('viewBookings.tableColumn.pickup') },
  { label: translate('viewBookings.tableColumn.trip') },
  { label: translate('viewBookings.tableColumn.dropOff') },
  { label: translate('viewBookings.tableColumn.agent') },
  { label: translate('viewBookings.tableColumn.person') },
  { label: translate('viewBookings.tableColumn.assocAgent') },
  { label: translate('viewBookings.tableColumn.marketSource') },
];

export const bookingHeaderKeyMapping: Record<string, string> = {
  date: 'actualDate',
  id: 'bookingId',
  status: 'status',
  name: 'paxName',
  pretravel: 'surveyStatus',
  cxl: 'cxlSurveyStatus',
  ad: 'adults',
  ch: 'children',
  inf: 'infants',
  trip: 'tripName',
  d1opschecklist:'d1OpsNote',
  time:'pickupTime',
  pickup: 'pickup',
  dropoff: 'dropoff',
  agent: 'agentName',
  person: 'bookedBy',
  assocagent: 'assocAgentName',
  marketsource: 'marketSource',
};

export const dropOffHeader = [
  { label: translate('busAllocation.tableColumn.id') },
  { label: translate('busAllocation.tableColumn.pickup') },
  { label: translate('busAllocation.tableColumn.dropoff') },
  { label: translate('busAllocation.tableColumn.tour') },
  { label: translate('busAllocation.tableColumn.comment') },
  { label: translate('busAllocation.tableColumn.name') },
  { label: translate('busAllocation.tableColumn.luggage') },
  { label: translate('busAllocation.tableColumn.agent') },
  { label: translate('busAllocation.tableColumn.balloon') },
  { label: translate('busAllocation.tableColumn.allocated') },
  { label: translate('busAllocation.tableColumn.flights') },
  { label: translate('busAllocation.tableColumn.pax') },
];

export const dropOffHeaderKeyMapping: Record<string, string> = {
  id: 'bookingId',
  pickup: 'pickup',
  dropoff: 'dropOff',
  trip: 'productName',
  comment: 'comment',
  name: 'paxName',
  "l'ge": 'luggage',
  agent: 'agentName',
  balloon: 'allocBalloon',
  al: 'allocPax',
  flt: 'flightNo',
  pax: 'paxNo',
};

export const pickupHeader = [
  { label: translate('busAllocation.tableColumn.id') },
  { label: translate('busAllocation.tableColumn.pickup') },
  { label: translate('busAllocation.tableColumn.dropoff') },
  { label: translate('busAllocation.tableColumn.tour') },
  { label: translate('busAllocation.tableColumn.comment') },
  { label: translate('busAllocation.tableColumn.name') },
  { label: translate('busAllocation.tableColumn.luggage') },
  { label: translate('busAllocation.tableColumn.agent') },
  { label: translate('busAllocation.tableColumn.balloon') },
  { label: translate('busAllocation.tableColumn.allocated') },
  { label: translate('busAllocation.tableColumn.flights') },
  { label: translate('busAllocation.tableColumn.pax') },
];
export const pickupHeaderKeyMapping: Record<string, string> = {
  id: 'bookingId',
  pickup: 'pickup',
  dropoff: 'dropOff',
  trip: 'productName',
  comment: 'comment',
  name: 'paxName',
  "l'ge": 'luggage',
  agent: 'agentName',
  balloon: 'allocBalloon',
  al: 'allocPax',
  flt: 'flightNo',
  pax: 'paxNo',
};

export const flightHeader = [
  { label: translate('flightAllocation.tableColumn.id') },
  { label: translate('flightAllocation.tableColumn.pickup') },
  { label: translate('flightAllocation.tableColumn.dropoff') },
  { label: translate('flightAllocation.tableColumn.trip') },
  { label: translate('flightAllocation.tableColumn.comment') },
  { label: translate('flightAllocation.tableColumn.er') },
  { label: translate('flightAllocation.tableColumn.name') },
  { label: translate('flightAllocation.tableColumn.agent') },
  { label: translate('flightAllocation.tableColumn.allocated') },
  { label: translate('flightAllocation.tableColumn.flight') },
  { label: translate('flightAllocation.tableColumn.pax') },
  { label: translate('flightAllocation.tableColumn.m') },
  { label: translate('flightAllocation.tableColumn.f') },
  { label: translate('flightAllocation.tableColumn.ch') },
  { label: translate('flightAllocation.tableColumn.mfch') },
];

export const flightHeaderKeyMapping: Record<string, string> = {
  id: 'bookingId',
  pickup: 'pickup',
  dropoff: 'dropoff',
  trip: 'productName',
  comment: 'comment',
  er: 'earlyReturn',
  name: 'paxName',
  agent: 'agentName',
  al: 'allocNo',
  flt: 'flightNo',
  pax: 'paxNo',
  m: 'male',
  f: 'female',
  ch: 'children',
  'm\\f\\ch': 'm\\f\\ch',
};

export const passengerManifestHeader = [
  { label: 'S No.' },
  { label: 'HA Ref' },
  { label: "Passenger's Name" },
  { label: 'Not On This Flight' },
  { label: 'Hotel or Meeting Point' },
  { label: 'Country' },
];
// left hand side header label and right hand side field name
export const passengerManifestHeaderKeyMapping: Record<string, string> = {
  'sno.': 'id',
  haref: 'haRef',
  "passenger'sname": 'name',
  hotelormeetingpoint: 'hotel',
  country: 'country',
};

 export const weatherLabels = [
   { key: 'wind1', label: translate('operation.weatherLabel.1000') },
   { key: 'wind2', label: translate('operation.weatherLabel.2000') },
   { key: 'wind3', label: translate('operation.weatherLabel.3000') },
   { key: 'wind4', label: translate('operation.weatherLabel.5000') },
   { key: 'swsd', label: translate('operation.weatherLabel.swsd') },
   { key: 'pressure', label: translate('operation.weatherLabel.pressure') },
 ];


//  Compliance page header label

export const upcomingStaffCompliancesHeader = [
  { label: translate('compliances.commonTableHeader.name') },
  { label: translate('compliances.commonTableHeader.compliance') },
  { label: translate('compliances.commonTableHeader.category') },
  { label: translate('compliances.commonTableHeader.status') },
  { label: translate('compliances.commonTableHeader.allocatedTo') },
];

export const upcomingVehicleTrailerCompliancesHeader = [
  { label: translate('compliances.commonTableHeader.vehicle') },
  { label: translate('compliances.commonTableHeader.name') },
  { label: translate('compliances.commonTableHeader.compliance') },
  { label: translate('compliances.commonTableHeader.category') },
  { label: translate('compliances.commonTableHeader.status') },
  { label: translate('compliances.commonTableHeader.allocatedTo') },
];

export const upcomingAirCraftCompliancesHeader = [
  { label: translate('compliances.commonTableHeader.vehicle') },
  { label: translate('compliances.commonTableHeader.name') },
  { label: translate('compliances.commonTableHeader.compliance') },
  { label: translate('compliances.commonTableHeader.category') },
  { label: translate('compliances.commonTableHeader.status') },
  { label: translate('compliances.commonTableHeader.allocatedTo') },
];

export const pilotHoursCompliancesHeader = [
  { label: translate('compliances.commonTableHeader.pilotHours') },
  { label: translate('compliances.commonTableHeader.restsDays') },
  { label: translate('compliances.commonTableHeader.sevenDaysHrs') },
  { label: translate('compliances.commonTableHeader.fourteenDaysHrs') },
];

export const driverHoursCompliancesHeader = [
  { label: translate('compliances.commonTableHeader.driverSummary') },
  { label: translate('compliances.commonTableHeader.restDaysInFourteen') },
  { label: translate('compliances.commonTableHeader.conSecMinTwo') },
  { label: translate('compliances.commonTableHeader.kkdDays') },
  { label: translate('compliances.commonTableHeader.conSecMax') },
  { label: translate('compliances.commonTableHeader.kkdDate') },
];

